import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";

import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import BuyNowCoures from "../components/Team/BuyNowCoures";
import FooterAmani from "../components/Footer/FooterAmani";

const EmotionalAwareness = () => {
  return (
    <div className="body_wrapper">
       <CustomNavbar mClass="erp_menu" hbtnClass="er_btn" nClass="mr-auto" />
      {/* <Breadcrumb
        breadcrumbClass="breadcrumb_area breadcrumb_area_three"
        imgName="Img-05.jpg"
        Ptitle="Our CouresBook"
        Pdescription="Why I say old chap that is spiffing off his nut arse pear shaped plastered Jeffrey bodge barney some dodgy.!!"
      /> */}
      <BuyNowCoures/>
      {/* <FooterTwo FooterData={FooterData} /> */}
      <FooterAmani/>
    </div>
  );
};
export default EmotionalAwareness;
